import { FormFieldError } from '@forms/FormFieldError/FormFieldError';
import { Input, Select } from '@iwoca/orion';
import { FieldErrorsImpl, UseFormRegister } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { months } from '../../../../../../helpers/months';
import { TFormValues } from '../MSHForm.types';
import styles from '../MSHModal.module.css';

const DOBFields = ({
    errors,
    register,
    disabled
}: {
    errors: FieldErrorsImpl<TFormValues>;
    register: UseFormRegister<TFormValues>;
    disabled: boolean;
}) => {
    const intl = useIntl();

    return (
        <div className={styles.fields}>
            {(errors.day || errors.month || errors.year) && (
                <FormFieldError
                    message={intl.formatMessage({
                        id: '_.modal.major_shareholder_check_form.error.valid_DOB_required',
                        defaultMessage: 'Please enter a valid date of birth'
                    })}
                />
            )}

            <label className={styles.label}>Date of birth</label>

            {/* eslint-disable-next-line iwoca/input-a11y */}
            <Input
                {...register('day', {
                    required: true,
                    minLength: {
                        value: 2,
                        message: 'Please enter a valid number between 01-31'
                    },
                    maxLength: {
                        value: 2,
                        message: 'Please enter a valid number between 01-31'
                    }
                })}
                minLength={2}
                maxLength={2}
                wrapperClassName={`${styles.day} ${styles.field}`}
                id={'day'}
                placeholder={intl.formatMessage({
                    id: '_.modal.major_shareholder_check_form.day_field_placeholder',
                    defaultMessage: 'Day (e.g. 05)'
                })}
                disabled={disabled}
            />
            <Select
                {...register('month', {
                    required: true
                })}
                wrapperClassName={`${styles.month} ${styles.field}`}
                id="month"
                placeholder={intl.formatMessage({
                    id: '_.modal.major_shareholder_check_form.month_field_placeholder',
                    defaultMessage: 'Month'
                })}
                data-testid="month"
                disabled={disabled}
            >
                {months.map(({ value, label }, index) => (
                    <option key={index + value} value={value}>
                        {label}
                    </option>
                ))}
            </Select>
            {/* eslint-disable-next-line iwoca/input-a11y */}
            <Input
                {...register('year', {
                    required: true,
                    minLength: {
                        value: 4,
                        message: 'Please enter a valid year'
                    },
                    maxLength: {
                        value: 4,
                        message: 'Please enter a valid year'
                    }
                })}
                minLength={4}
                maxLength={4}
                wrapperClassName={`${styles.year} ${styles.field}`}
                id={'year'}
                placeholder={intl.formatMessage({
                    id: '_.modal.major_shareholder_check_form.year_field_placeholder',
                    defaultMessage: 'Year (e.g. 1995)'
                })}
                disabled={disabled}
            />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default DOBFields;
